/*global FilePond, FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginImageValidateSize, myModal */

var reviewUpload = {
    form: $('#review-form'),
    fileList: [],
    isFromCheck: false,
    pond: [],
    isValidationEnabled: false,
    init: function() {
        reviewUpload.action();
    },
    action: function() {
        FilePond.registerPlugin(FilePondPluginFileValidateType);
        FilePond.registerPlugin(FilePondPluginFileValidateSize);
        FilePond.registerPlugin(FilePondPluginImageValidateSize);
        reviewUpload.initialRender();
    },
    validationRuleMessages: {
        fullname: {
            required: _d.t.fieldRequired,
            fullname: _d.t.enterFullName
        }
    },
    validationRules: {
        fullname: {
            fullname: true,
            required: true
        },
        reason: {
            required: true,
            minlength: 10
        }
    },

    initialRender: function() {

        $('.my-pond').each(function(index) {
            const that = $(this);
            const maxCount = that.data('count');

            if (maxCount !== '') {
                reviewUpload.filepondRules.maxFiles = parseInt(maxCount);
                reviewUpload.filepondRules.maxParallelUploads = parseInt(maxCount);
            }

            reviewUpload.pond[index] = FilePond.create(this, reviewUpload.filepondRules);
            reviewUpload.pond[index].on('addfile', (error, file) => {
                reviewUpload.checkForFileDuplicates(file);
            });

            reviewUpload.pond[index].on('removefile', (_, file) => {
                reviewUpload.removeFromFileList(file);
            });
        });
        reviewUpload.isValidationEnabled = true;
    },
    filepondRules: {
        allowFileTypeValidation: true,
        acceptedFileTypes: ['image/png', 'image/jpeg'],
        labelInvalidField: _d.t.labelInvalidField,
        labelFileWaitingForSize: _d.t.labelFileWaitingForSize,
        labelFileSizeNotAvailable: _d.t.labelFileSizeNotAvailable,
        labelFileLoading: _d.t.labelFileLoading,
        labelFileLoadError: _d.t.labelFileLoadError,
        labelFileProcessing: _d.t.labelFileProcessing,
        labelFileProcessingComplete: _d.t.labelFileProcessingComplete,
        labelFileProcessingAborted: _d.t.labelFileProcessingAborted,
        labelFileProcessingError: _d.t.labelFileProcessingError,
        labelFileProcessingRevertError: _d.t.labelFileProcessingRevertError,
        labelFileRemoveError: _d.t.labelFileRemoveError,
        labelTapToCancel: _d.t.labelTapToCancel,
        labelTapToRetry: _d.t.labelTapToRetry,
        labelTapToUndo: _d.t.labelTapToUndo,
        labelButtonRemoveItem: _d.t.labelButtonRemoveItem,
        labelButtonAbortItemLoad: _d.t.labelButtonAbortItemLoad,
        labelButtonRetryItemLoad: _d.t.labelButtonRetryItemLoad,
        labelButtonAbortItemProcessing: _d.t.labelButtonAbortItemProcessing,
        labelButtonUndoItemProcessing: _d.t.labelButtonUndoItemProcessing,
        labelButtonRetryItemProcessing: _d.t.labelButtonRetryItemProcessing,
        labelButtonProcessItem: _d.t.labelButtonProcessItem,
        fileValidateTypeLabelExpectedTypes: _d.t.fileValidateTypeLabelExpectedTypes,
        labelFileTypeNotAllowed: _d.t.fileOfInvalidType,
        labelIdle: _d.t.dragAndDrop,
        labelMaxFileSize: _d.t.labelMaxFileSize,
        labelMaxFileSizeExceeded: _d.t.fileIsTooLarge,
        labelMaxTotalFileSize: _d.t.labelMaxTotalFileSize,
        allowFileSizeValidation: true,
        maxFileSize: '16MB',
        maxTotalFileSize: '100MB',
        allowMultiple: true,
        allowImageValidateSize: true,
        imageValidateSizeMinWidth: 900,
        imageValidateSizeMinHeight: 600,
        imageValidateSizeLabelImageSizeTooSmall: _d.t.imageValidateSizeLabelImageSizeTooSmall,
        imageValidateSizeLabelExpectedMinSize: _d.t.imageValidateSizeLabelExpectedMinSize,

        server: {
            url: _d.url.reservation.fileUpload
                .replace('number', $('#reservation-number').val())
                .replace('email', $('#email').val()),
            process: {
                method: 'POST',
                withCredentials: false,
                headers: {},
                timeout: 7000,
                onload: function(res) {
                    const obj = JSON.parse(res);
                    return obj.tmp_filename;
                },
                onerror: null,
                ondata: null
            },
            revert: {
                method: 'DELETE',
                withCredentials: false,
                headers: {},
                timeout: 7000
            }
        }
    },
    checkForFileDuplicates(file) {
        const fileInList = reviewUpload.fileList.find((photo) => (photo.name === file.filename) && (photo.size === file.fileSize));

        if (fileInList) {
            file.abortLoad();
            reviewUpload.isFromCheck = true;
            return;
        }

        reviewUpload.fileList.push({
            name: file.filename,
            size: file.fileSize
        });

    },
    removeFromFileList(file) {
        if (reviewUpload.isFromCheck) {
            reviewUpload.isFromCheck = false;
            return;
        }

        const filteredList = reviewUpload.fileList.filter((photo) => photo.name !== file.filename);

        reviewUpload.fileList = [...filteredList];
    }
};
